import * as React from "react";
import * as History from "history";
import { withRouter } from "react-router";

/**
 * Helper component that listens for route changes and resets scroll position
 */

interface Props {
  children?: React.ReactNode;
  location: History.Location;
}

const ScrollToTop: React.FC<Props> = ({ location, children }) => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <React.Fragment>{children}</React.Fragment>;
};

export default withRouter(ScrollToTop);
